// extracted by mini-css-extract-plugin
module.exports =  {"carbonDate":"carbonDate_CXx7wzQg"};